module.exports = __webpack_public_path__ + "static/img/new.780ed36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new.png
// module id = PUex
// module chunks = 1